import { colors, fontStyle } from "Constants";

const styles = {
  checkbox: {
    height: "24px",
    width: "24px",
    borderRadius: "4px",
  },
  searchCustomStyle: {
    flex: 0.6,
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "12px",
    paddingBottom: "12px",
  },
  searchActiveCustomStyle: {
    border: `1px solid ${colors.blue400}`,
  },
  searchFilterContainer: {
    display: "flex",
    flex: 0.4,
    flexDirection: "row",
    borderWidth: "1px",
    borderColor: "#dbdbdb",
    borderStyle: "solid",
    borderLeftWidth: "0px",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fafafa",
    cursor: "default",
  },
  searchFilterText: {
    maxWidth: "130px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
  },
  arrowIcon: {
    marginLeft: "8px",
  },
  searchButtonContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0px 12px",
  },
  buttonParentStyle: {
    width: "100%",
    justifyContent: "center",
  },
  buttonComponentStyle: {
    justifyContent: "center",
  },
  customTitleStyle: {
    fontFamily: fontStyle.demiBold.fontFamily,
  },
  checkboxItemStyle: {
    height: "24px",
    width: "24px",
    borderRadius: "4px",
  },
  mainHeaderStyles: {
    fontSize: "1.6rem",
    color: colors.textDefault,
    lineHeight: "2.4rem",
    fontWeight: "600",
  },
  nodeSpanStyle: {},
  mainContentContainerStyle: {
    marginBottom: "0px",
    padding: "0px 16px 0px 12px",
  },
  linearViewContainerStyle: {
    marginBottom: "0px",
    padding: "0px 8px 0px 12px",
  },
  nodeLabelStyle: [
    {
      depth: 3,
      style: {
        marginBottom: "4px",
      },
    },
    {
      depth: 2,
      style: {
        marginBottom: "16px",
      },
    },
    {
      depth: 0,
      style: {
        marginTop: "8px",
      },
    },
  ],
  itemsViewContainerStyle: {
    display: "flex",
    flexDirection: "column",
    padding: "0px 32px 24px 16px",
    overflowY: "auto",
    width: "50%",
    flex: "2",
  },
  customCountStyle: {
    fontWeight: "500",
    marginRight: "0px",
    color: colors.textSubtle,
  },
  headerStyle: { padding: "0px 12px !important" },
  checkboxContainerStyle: {
    height: "fit-content",
    alignSelf: "flex-start",
    marginTop: "2px",
  },
  searchContainerStyle: {
    zIndex: 1500,
    backgroundColor: "white",
    width: "40%",
    marginTop: "8px",
    boxShadow: "0px 5px 10px 0px rgba(0, 46, 57, 0.15)",
    borderRadius: "8px",
    overflowX: "hidden",
    maxHeight: "60%",
  },
  leftArrowStyle: {
    marginRight: "0px",
  },
  itemsViewContainerStyleDepth2: {
    display: "flex",
    flexDirection: "column",
    padding: "12px 32px 24px 16px",
    overflowY: "auto",
    width: "50%",
    flex: "2",
  },
  standardTableContainer: {
    paddingBottom: "20px",
  },
  labelStyles: { color: colors.textDefault },
};

export default styles;
